export default __webpack_public_path__ + "static/media/profile-bg.80038b63.svg";